import {StateCreator} from 'zustand'

export interface ICurrentFilters {
  statuses: string[]
  goals: string[]
  owners: string[]
  dates: string[]
}

export interface IInitiativesStore {
  // UI-only state
  initiativesGridPage: number
  filtersCount: number
  currentFilters: ICurrentFilters

  // sync actions
  resetInitiatives: () => void
  abortRequest: () => void
  setSelectedFilters: (filters: ICurrentFilters) => void
}

const initialInitiativesState = {
  initiativesGridPage: 1,
  filtersCount: 0,
  currentFilters: {statuses: [], goals: [], owners: [], dates: []},
}

export const createInitiativesSlice: StateCreator<
  IInitiativesStore,
  [],
  [],
  IInitiativesStore
> = set => ({
  ...initialInitiativesState,

  resetInitiatives: () =>
    set({
      initiativesGridPage: 1,
      filtersCount: 0,
      currentFilters: {statuses: [], goals: [], owners: [], dates: []},
    }),

  // no-op: React Query handles request cancellation automatically
  abortRequest: (): void => {},

  setSelectedFilters: filters =>
    set({
      currentFilters: filters,
      filtersCount:
        filters.statuses.length +
        filters.goals.length +
        filters.owners.length +
        filters.dates.length,
    }),
})
